import classNames from 'classnames';
import React from 'react';
import style from './style.module.scss';
import type { IProps } from './types';

/**
 * Label row rendered above a form input. Emits nothing when the title is empty, otherwise renders the title paragraph preceded by a red asterisk when the field is required, merging the extra class onto the wrapper.
 *
 * @param title - The label text; nothing is rendered when it is empty.
 * @param className - Extra class applied to the title wrapper.
 * @param isRequired - Whether the required asterisk is shown.
 * @returns The title row, or an empty fragment.
 */
const InputTitle = ({ title, className, isRequired }: IProps): React.ReactNode =>
  title && (
    <div className={classNames(style.inputTitleWrapper, className)}>
      {isRequired && <div className={style.requiredIcon}>*</div>}
      <p>{title}</p>
    </div>
  );

export default InputTitle;
